import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';

export default function Login({ navigate }) {
  const { login } = useAuth();
  const [email, setEmail]       = useState('');
  const [password, setPassword] = useState('');
  const [showPw, setShowPw] = useState(false);
  const [error, setError]       = useState('');
  const [loading, setLoading]   = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(''); setLoading(true);
    try {
      const res  = await fetch('/api/auth/login', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password })
      });
      const data = await res.json();
      if (res.ok) { login(data.token, data.user); }
      else setError(data.error || 'Invalid email or password');
    } catch { setError('Connection error — is the server running?'); }
    setLoading(false);
  };

  return (
    <div className="auth-wrap">
      <div className="auth-card">
        <div className="auth-logo">
          <div className="auth-logo-icon">🧬</div>
          <div style={{ fontSize: 13, fontWeight: 600, color: 'var(--text-3)', letterSpacing: 1.5, textTransform: 'uppercase' }}>
            Enpower <span style={{ color: 'var(--blue)' }}>Org DNA</span>
          </div>
        </div>

        <div className="auth-title">Welcome back</div>
        <div className="auth-sub">Sign in to your consulting workspace</div>

        <form onSubmit={submit}>
          {error && <div className="form-error" style={{ marginBottom: 18 }}>{error}</div>}

          <div className="form-group">
            <label className="form-label">Email address</label>
            <input className="form-input" type="email" placeholder="you@company.com"
              value={email} onChange={e => setEmail(e.target.value)} required autoFocus />
          </div>

          <div className="form-group" style={{ marginBottom: 24 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 6 }}>
              <label className="form-label" style={{ margin: 0 }}>Password</label>
              <span className="auth-link" style={{ fontSize: 12.5 }} onClick={() => navigate('/forgot-password')}>
                Forgot password?
              </span>
            </div>
            <div style={{position:'relative'}}>
              <input className="form-input" type={showPw?'text':'password'} placeholder="••••••••"
                value={password} onChange={e=>setPassword(e.target.value)} required style={{paddingRight:40}}/>
              <span onClick={()=>setShowPw(p=>!p)} style={{position:'absolute',right:12,top:'50%',transform:'translateY(-50%)',cursor:'pointer',fontSize:16,color:'var(--text-3)',userSelect:'none'}}>
                {showPw?'🙈':'👁'}
              </span>
            </div>
          </div>

          <button type="submit" className="btn btn-primary btn-lg" style={{ width: '100%', justifyContent: 'center' }} disabled={loading}>
            {loading ? <><span className="loader loader-sm" style={{ borderTopColor: '#fff' }}></span> Signing in…</> : 'Sign in'}
          </button>
        </form>

        <div className="auth-footer">
          Don't have an account?{' '}
          <span className="auth-link" onClick={() => navigate('/register')}>Create account</span>
        </div>
      </div>
    </div>
  );
}
